{
  "es": {
    "client": {
      "actions": {
        "changeBackgroundImage": "Cambiar imagen de inicio de sesión",
        "new": "Añadir cuenta",
        "setAsPrimary": "Establecer como principal",
        "submit": "Guardar",
        "undoChanges": "Deshacer cambios"
      },
      "attributes": {
        "address": "Dirección",
        "aftercare_conversation_enabled": "Conversaciones de posventa",
        "backgroundImage": "Imagen de la pantalla de inicio de sesión",
        "email_address": "Correo electrónico",
        "email_address_invoicing": "Correo electrónico de facturación",
        "email_address_renewal": "Correo electrónico de recordatorio de renovación del contrato",
        "email_address_reply_to": "Correo electrónico de respuesta (\"Reply-to\")",
        "email_address_ziggu": "Correo electrónico del remitente (\"From\")",
        "iban": "IBAN",
        "language": "Idioma",
        "languages": "Idiomas de la organización",
        "name": "Nombre",
        "phone": "Teléfono",
        "storage_sum": "Uso de almacenamiento",
        "storage_sum_max": "{percentage}% de {gigabytes} GB",
        "subdomain": "Subdominio",
        "timezone": "Zona horaria",
        "vat_number": "Número de IVA"
      },
      "client_types": {
        "architects_designers": "Arquitectos y diseñadores",
        "creative_agencies": "Agencias creativas",
        "general_specialized_contractors": "Contratistas generales y especializados",
        "makers_manufacturers": "Fabricantes y artesanos",
        "planners_coordinators": "Planificadores y coordinadores",
        "property_developers": "Promotores inmobiliarios"
      },
      "integrations": {
        "api_docs_info": "Para más información sobre nuestra API, visita nuestra",
        "api_documentation": "documentación de la API"
      },
      "labels": {
        "activeProjects": "Proyectos activos",
        "activeProjectsUsed": "{0} proyectos activos, {1} sin usar todavía",
        "activeUnits": "Unidades activas",
        "activeUnitsUsed": "{0} unidades activas, {1} sin usar todavía",
        "after_care_categories": "Categorías",
        "after_care_statuses": "Estados",
        "aftercare": "Posventa",
        "bookADemo": "Reserva una demo",
        "by": "Por {client}",
        "categories": "Categorías",
        "category": "Categoría",
        "chatWithUs": "Chatea con nosotros",
        "companyProfile": "Perfil de la organización",
        "contactIntercom": "Contáctanos por el chat si quieres cambiar esto.",
        "contactZiggu": "¿Tienes una pregunta para Ziggu? ¿Te has atascado con algo? ¿Quieres consejo sobre el producto? ¡Hablemos!",
        "conversations": "Conversaciones",
        "dashboard": "Inicio",
        "decisions": "Decisiones",
        "default_payment_overdue": "Tienes una factura de Ziggu vencida. Págala de inmediato para evitar intereses. ¿Alguna duda? No dudes en contactarnos.",
        "delete_category": "¿Eliminar la categoría {category}?",
        "delete_category_expl": "Eliminar una categoría de documento no se puede deshacer. Los documentos existentes con esta categoría pasarán a la categoría Otro",
        "document_categories": "Categorías",
        "documents": "Documentos",
        "email_address_invoicing_info": "Enviaremos las nuevas facturas a esta dirección.",
        "email_address_renewal_info": "Te enviaremos correos a esta dirección cuando se acerque la fecha de renovación de tu suscripción, junto con toda la información necesaria.",
        "email_address_reply_to": "Esta dirección de correo se usará si alguien responde a un correo enviado a través de {email_address_ziggu}. Contáctanos por el chat si quieres cambiar esto.",
        "email_address_ziggu": "Esta dirección de correo se usará como remitente de todos los correos enviados desde la plataforma (correos de notificaciones, invitaciones, restablecimiento de contraseña, etc.)",
        "email_forwarder_must_be_owner": "Solo los empleados con el rol de 'Propietario' pueden reenviar correos.",
        "email_forwarding_activated": "El reenvío de correo está activo",
        "email_forwarding_activated_project": "El reenvío de correo del proyecto está activo",
        "email_forwarding_disclaimer": "Para evitar el spam, solo se procesan los correos enviados desde una dirección vinculada a un <b>perfil de Propietario/Mantenedor existente</b>.<br>Los correos de remitentes desconocidos se ignorarán.",
        "email_forwarding_is": "Tu dirección de reenvío es",
        "financials": "Finanzas",
        "general": "General",
        "goToSettings": "Ajustes",
        "helpcenter": "Centro de ayuda",
        "inbound_email": "Correo entrante",
        "invoice_overdue": "Tienes un pago atrasado. Contacta con accounting{'@'}ziggu.io para más información.",
        "invoice_overdue_title": "Factura vencida",
        "language": "Este es el idioma predeterminado de la organización para tu página de inicio de sesión, los clientes y los empleados.",
        "languages": "El idioma principal es el predeterminado para introducir contenido y no se puede eliminar. Añade idiomas adicionales para admitir contenido multilingüe. Haz clic en cualquier idioma adicional para convertirlo en el principal.",
        "mobile_app_disabled": "App móvil (PWA) no activa",
        "mobile_app_enabled": "App móvil (PWA) activa",
        "mobile_app_info": "¡Escríbenos por Intercom para más información!",
        "mustBeJPG": "Debe ser una imagen .jpg",
        "new_categories": "Categorías adicionales",
        "new_document_category": "Categoría",
        "noCategories": "Aún no tienes categorías. Crea una para empezar.",
        "other": "Otro",
        "outOfOffice": "Fuera de la oficina",
        "outOfOfficeMessage": "Mensaje de fuera de la oficina (opcional)",
        "packageUnits": "Suscrito para",
        "primary": "Principal",
        "removed_user": "Usuario eliminado",
        "settings": {
          "click_to_copy": "Haz clic para copiar el token al portapapeles",
          "copied_to_clipboard": "Token copiado al portapapeles"
        },
        "snippets": "Fragmentos",
        "subscription": "Suscripción",
        "subscriptionRenewalDate": "Fecha de renovación",
        "subscriptionUsageUnits": "Uso actual",
        "tab_aftercare": "Posventa",
        "tab_billing": "Facturación",
        "tab_branding": "Marca",
        "tab_features": "Funciones",
        "tab_general": "General",
        "tab_information": "Información",
        "tab_integrations": "Integraciones",
        "tickets": "Conversaciones",
        "timezone": "Esta es la zona horaria predeterminada de la organización.",
        "translation_not_added_yet": "Aún no se ha añadido la traducción",
        "unchangeable_categories": "Categorías predeterminadas que no se pueden modificar",
        "unchangeable_categories_info": "Estas categorías son necesarias para que el sistema funcione correctamente o se están utilizando en integraciones.",
        "upgradePackageContactUs": "Contáctanos para empezar",
        "upgradePackageSubtitleAftercare": "Esta función te permite hacer seguimiento a los clientes después de la entrega y ayudarles a resolver cualquier incidencia con su nueva vivienda",
        "upgradePackageSubtitleConversationMentions": "Esta función te permite escribir notas privadas y mencionar a empleados en una conversación",
        "upgradePackageSubtitleFinancials": "Crea una vista general financiera de cada comprador al instante",
        "upgradePackageSubtitleMilestones": "Esta función te permite comunicar el progreso de la construcción de forma sencilla a tu cliente",
        "upgradePackageSubtitleMultipleCustomerSingleUnit": "Esta función te permite invitar a un segundo cliente a la plataforma Ziggu",
        "upgradePackageTitle": "Parece que aún no tienes esta función",
        "warningooo": "Fuera de la oficina activo",
        "yourEmail": "Tu correo",
        "zigguHome": "Ziggu Home"
      },
      "project_types": {
        "mup": "MUPs",
        "sup": "SUPs"
      },
      "toasts": {
        "attachment_category": {
          "create": "Categoría de documento creada",
          "update": "La categoría de documento se ha actualizado"
        }
      },
      "validation": {
        "attachment_category_required": "La categoría es obligatoria",
        "duplicated_translation": "Traducción duplicada",
        "mustBeEmailAddress": "Debe ser una dirección de correo electrónico",
        "needName": "El nombre es obligatorio"
      }
    }
  }
}
